import type { DataTableProps } from './data-table.interface'
import { useDataTable } from './useDataTable.hook'
import { useDataTableProps } from './useDataTableProps.hook'
import { useDataTableToolbar } from './useDataTableToolbar.hook'

/**
 * Combines all data table state management into a single hook.
 * Returns normalized props, table state, and toolbar configuration.
 */
export const useDataTableState = <TData>(props: DataTableProps<TData>) => {
  const p = useDataTableProps(props)

  const tableState = useDataTable({
    data: p.data,
    columnList: p.columnList,
    getRowId: p.getRowId,
    isSelectable: p.isSelectable,
    selectedIdList: p.selectedIdList,
    onSelectionChange: p.onSelectionChange,
    actionList: p.actionList,
    bulkActionList: p.bulkActionList,
    sortBy: p.sortBy,
    sortOrder: p.sortOrder,
    onSortChange: p.onSortChange,
    onSearchChange: p.onSearchChange,
    filterList: p.filterList,
    toolbarActions: p.toolbarActions,
  })

  const { hasToolbar, toolbarProps } = useDataTableToolbar({
    searchValue: p.searchValue,
    onSearchChange: p.onSearchChange,
    searchPlaceholder: p.searchPlaceholder,
    filterList: p.filterList,
    filterValueList: p.filterValueList,
    onFilterChange: p.onFilterChange,
    selectedIdList: p.selectedIdList,
    bulkActionList: p.bulkActionList,
    toolbarActions: p.toolbarActions,
    isLoading: p.isLoading,
    onBulkAction: tableState.handleBulkAction,
  })

  return { p, tableState, hasToolbar, toolbarProps }
}
